module.exports = __webpack_public_path__ + "static/media/QC.f6701906.svg";